export default __webpack_public_path__ + "static/media/Back_Arrow.4cca97e1.svg";